import { Route, Navigate } from 'react-router-dom';

const PrivateRoute = ({ children }) => {
  // Always allow access
  return children;
};

export default PrivateRoute;
